import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { getPendingJobs } from '@/services/evaluationApi';

/**
 * Fetch and track all in-flight evaluation jobs for the current user.
 *
 * - F5: Only polls every 5 s when there are active jobs; goes idle otherwise
 *   to avoid burning 720 requests/hour for idle users.
 * - refetchOnWindowFocus: true ensures the list refreshes when the tab is
 *   foregrounded (iOS Safari recovery + desktop multi-tab use).
 * - F2: 401 responses stop retries immediately (session expired).
 */
export function usePendingJobs() {
  return useQuery({
    queryKey: ['pending-jobs'],
    queryFn: () => getPendingJobs(['queued', 'processing']),
    refetchOnWindowFocus: true,
    // F5 — poll only when jobs are present; stop when the list empties.
    refetchInterval: (q) => ((q.state.data?.length ?? 0) > 0 ? 5_000 : false),
    // F2 — don't retry 401s (expired session).
    retry: (failureCount, error) =>
      !(isAxiosError(error) && error.response?.status === 401) && failureCount < 2,
  });
}
